import React, { useEffect } from "react";
import { useState } from "react";
import { Button, Chip, Icon, Modal } from "react-materialize";
import { useDispatch, useSelector } from "react-redux";
import {
  addScrapToNetwork,
  assignLocationToNetwork,
} from "../../../redux/action/organization";
import { notify } from "../../../helpers/helper";

export const EditLocationsPresent = ({ associatedLocations, network }) => {
  const [scrap, setScrap] = useState("");
  const { organization, networkLoading } = useSelector(
    (state) => state.organization
  );
  const dispatch = useDispatch();
  const [selectedLocations, setSelectedLocations] = useState([]);

  const associatedLocationIds = associatedLocations.map((loc) =>
    typeof loc === "object" ? loc._id : loc
  );

  useEffect(() => {
    let purged = associatedLocationIds.filter((locId) =>
      organization.locations.map((loc) => loc._id).includes(locId)
    );

    setSelectedLocations(purged);
  }, [associatedLocations, organization.locations]);

  return (
    <Modal
      trigger={<p className="pointer">Edit Locations </p>}
      style={{ borderRadius: "10px" }}
      actions={[]}
      id="edit-locations-modal"
    >
      <p className="bold">Edit Locations</p>
      <p>Add or remove your locations for which this network interacts with.</p>
      <p className="bold">{network?.name}</p>

      <div className="mt-1">
        <label className="black-text">Select locations</label>

        <div
          className="gap-1"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
          }}
        >
          {organization?.locations?.map((location, i) => {
            return (
              <div
                className={`chip ${
                  selectedLocations.includes(location._id)
                    ? "cercle-purple white-text"
                    : ""
                } pointer`}
                onClick={() => {
                  if (selectedLocations.includes(location._id)) {
                    setSelectedLocations(
                      selectedLocations.filter((loc) => loc !== location._id)
                    );
                  } else {
                    setSelectedLocations([...selectedLocations, location._id]);
                  }
                }}
              >
                {location.nickname}
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex gap-1 mt-2 ">
        <button
          className="modal-button"
          disabled={
            (associatedLocationIds.every((locId) =>
              selectedLocations.includes(locId)
            ) &&
              selectedLocations.length === associatedLocationIds.length) ||
            networkLoading
          }
          onClick={() => {
            dispatch(
              assignLocationToNetwork(
                { locations: selectedLocations, network: network._id },
                () => {
                  notify("Locations updated successfully", "success");
                  setSelectedLocations([]);
                  const elem = document.getElementById("edit-locations-modal");
                  const instance = window.M.Modal.getInstance(elem);
                  instance.close();
                }
              )
            );
          }}
        >
          Save
        </button>

        <Button modal="close" className="btn-outline  first-time-but ">
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export const EditScrapsPresent = ({ associatedScraps, network }) => {
  const [scrap, setScrap] = useState("");
  const { networkLoading } = useSelector((state) => state.organization);
  const { scraps } = useSelector((state) => state.scraps);
  const dispatch = useDispatch();
  const [selectedScraps, setSelectedScraps] = useState([]);

  const associatedScrapIds = associatedScraps.map((scrap) =>
    typeof scrap === "object" ? scrap._id : scrap
  );

  useEffect(() => {
    let purged = associatedScrapIds.filter((scrapId) =>
      scraps.map((scrap) => scrap._id).includes(scrapId)
    );

    setSelectedScraps(purged);
  }, [associatedScraps, scraps]);

  return (
    <Modal
      trigger={<p className="pointer">Edit Scraps </p>}
      style={{ borderRadius: "10px" }}
      actions={[]}
      id="edit-scraps-modal"
    >
      <p className="bold">Edit Scraps</p>
      <p>Add or remove the scraps for which this network interacts with.</p>
      <p className="bold">{network?.name}</p>

      <div className="mt-1">
        <label className="black-text">Select scraps</label>

        <div className="flex gap-1">
          {scraps?.map((scrap, i) => {
            return (
              <div
                className={`chip ${
                  selectedScraps.includes(scrap._id)
                    ? "cercle-purple white-text"
                    : ""
                } pointer`}
                onClick={() => {
                  if (selectedScraps.includes(scrap._id)) {
                    setSelectedScraps(
                      selectedScraps.filter((s) => s !== scrap._id)
                    );
                  } else {
                    setSelectedScraps([...selectedScraps, scrap._id]);
                  }
                }}
              >
                {scrap.name}-{scrap.variant}
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex gap-1 mt-2 ">
        <button
          className="modal-button"
          disabled={
            (associatedScrapIds.every((scrapId) =>
              selectedScraps.includes(scrapId)
            ) &&
              selectedScraps.length === associatedScrapIds.length) ||
            networkLoading
          }
          onClick={() => {
            dispatch(
              addScrapToNetwork(
                { scraps: selectedScraps, network: network._id },
                () => {
                  notify("Scraps updated successfully", "success");
                  setSelectedScraps([]);
                  const elem = document.getElementById("edit-scraps-modal");
                  const instance = window.M.Modal.getInstance(elem);
                  instance.close();
                }
              )
            );
          }}
        >
          Save
        </button>

        <Button modal="close" className="btn-outline  first-time-but ">
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
